// Globals
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledActionsWrapper, StyledCard, StyledTitle, StyledTitleWrapper } from './StepCardStyles';
import { StyledTag } from '../Styled';

// Models
import { StepStatus } from '@/models/step.model';

// Helpers
import { StepProgressStatus } from '../../helpers';

type TStepCardProps = {
  title: string;
  status?: StepStatus | StepProgressStatus;
  children?: ReactNode;
  actions?: ReactNode;
};

const StepCard = ({ title, children, status, actions }: TStepCardProps) => {
  const { t } = useTranslation('property');
  return (
    <StyledCard>
      <StyledTitleWrapper>
        <StyledTitle>{title}</StyledTitle>
        <StyledActionsWrapper>
          {actions}
          {status && <StyledTag $status={status}>{t(status)}</StyledTag>}
        </StyledActionsWrapper>
      </StyledTitleWrapper>
      {children}
    </StyledCard>
  );
};

export default StepCard;
